import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { Theme, ThemeOptions, ThemeProvider, createTheme } from '@mui/material/styles';
import { ReactNode, useMemo } from 'react';
import useConfig from '~/hooks/useConfig';

import componentsOverride from './overrides';
import Palette from './palette';
import CustomShadows from './shadows';
import typography from './typography';

type ThemeCustomizationProps = {
  children: ReactNode;
};

export default function ThemeCustomization({ children }: ThemeCustomizationProps) {
  const { themeDirection, mode } = useConfig();

  const themeOptions: ThemeOptions = useMemo(() => {
    const theme = Palette(mode);

    return {
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1536,
          xxl: 2560,
        },
      },
      direction: themeDirection,
      mixins: {
        toolbar: {
          minHeight: 60,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
      palette: theme.palette,
      customShadows: CustomShadows(theme),
      typography,
    };
  }, [mode, themeDirection]);

  const themes: Theme = createTheme(themeOptions);
  themes.components = componentsOverride(themes);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
